import { IdsInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const diffuseOtoIndividualHostFamiliesToParents = (input: IdsInput) => {
  return restApiClient
    .url(constructApiUrl(API.enrollments.diffuseOtoIndividualHostFamiliesToParents.url, null))
    .post(input)
}
